/** @format */

import { observable, action } from 'mobx';

class VisitedStore {
  @observable visited = [];

  @action fetchVisited = () => {
    let visited = window.localStorage.getItem('visited');
    if (visited) {
      this.visited = JSON.parse(visited);
    }
  };

  @action addToVisited = url => {
    if (!this.visited.includes(url)) {
      this.visited.push(url);
      window.localStorage.setItem('visited', JSON.stringify(this.visited));
    }
  };
}

export default new VisitedStore();
